// Tauri-only helpers. Everything is dynamically imported so the web bundle never loads the plugins.
// Keychain commands are implemented in apps/shell (Rust): auth_token_get / auth_token_set / auth_token_clear.

async function invoke<T>(cmd: string, args?: Record<string, unknown>): Promise<T> {
  const { invoke } = await import('@tauri-apps/api/core')
  return invoke<T>(cmd, args)
}

export async function keychainGetToken(): Promise<string | null> {
  return (await invoke<string | null>('auth_token_get')) ?? null
}

export async function keychainSetToken(token: string): Promise<void> {
  await invoke('auth_token_set', { token })
}

export async function keychainClearToken(): Promise<void> {
  await invoke('auth_token_clear')
}

export async function openInBrowser(url: string): Promise<void> {
  const { openUrl } = await import('@tauri-apps/plugin-opener')
  await openUrl(url)
}

/** Calls `handler` for deep links that started the app and for those arriving while it runs. */
export async function onDeepLink(handler: (url: string) => void): Promise<void> {
  const { getCurrent, onOpenUrl } = await import('@tauri-apps/plugin-deep-link')
  for (const url of (await getCurrent()) ?? []) handler(url)
  await onOpenUrl((urls) => {
    for (const url of urls) handler(url)
  })
}

/** Brings the main window to the front (deep links arrive while the app sits behind the browser). */
export async function focusMainWindow(): Promise<void> {
  const { getCurrentWindow } = await import('@tauri-apps/api/window')
  const win = getCurrentWindow()
  await win.unminimize().catch(() => {})
  await win.show().catch(() => {})
  await win.setFocus().catch(() => {})
}
